import {Box, useMantineTheme} from '@mantine/core';
import React from 'react';

import {ProcessFlowchartValidationError} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {STATUS_COLORS} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeV2Constants';

export function NodeErrorStatusTooltipContent({
  nodeErrors,
}: {
  nodeErrors: Array<ProcessFlowchartValidationError>;
}): JSX.Element {
  const theme = useMantineTheme();
  const errorColor = theme.colors[STATUS_COLORS.error.color][STATUS_COLORS.error.colorIndex];
  return (
    <Box>
      {nodeErrors.map((error, index) => (
        <Box
          key={`${error.errorType}-${index}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            marginBottom: index < nodeErrors.length - 1 ? '8px' : 0,
          }}
        >
          <BenchlingIcon icon="circle-xmark" style={{color: errorColor, height: 16, width: 16}} />
          {error.errorMessage}
        </Box>
      ))}
    </Box>
  );
}
